import {
  getBandAnalytics,
  getBandProductAnalytics,
  getBandProducts,
  getBandOrders,
  getBandMonthlyRevenues,
  getMonthlyBandRevenuesByPeriod,
} from "./asyncThunks";

// Band Analytics Builders
export const getBandAnalyticsBuilder = (builder) => {
  builder
    .addCase(getBandAnalytics.pending, (state) => {
      state.analytics.loading = true;
      state.analytics.error = null;
    })
    .addCase(getBandAnalytics.fulfilled, (state, action) => {
      state.analytics.loading = false;
      state.analytics.data = action.payload;
      state.analytics.error = null;
    })
    .addCase(getBandAnalytics.rejected, (state, action) => {
      state.analytics.loading = false;
      state.analytics.error = action.payload;
    });
};

export const getBandProductAnalyticsBuilder = (builder) => {
  builder
    .addCase(getBandProductAnalytics.pending, (state) => {
      state.productAnalytics.loading = true;
      state.productAnalytics.error = null;
    })
    .addCase(getBandProductAnalytics.fulfilled, (state, action) => {
      state.productAnalytics.loading = false;
      state.productAnalytics.data = action.payload;
      state.productAnalytics.error = null;
    })
    .addCase(getBandProductAnalytics.rejected, (state, action) => {
      state.productAnalytics.loading = false;
      state.productAnalytics.error = action.payload;
    });
};

// Band Products Builders
export const getBandProductsBuilder = (builder) => {
  builder
    .addCase(getBandProducts.pending, (state) => {
      state.products.loading = true;
      state.products.error = null;
    })
    .addCase(getBandProducts.fulfilled, (state, action) => {
      state.products.loading = false;
      state.products.data = action.payload;
      state.products.error = null;
    })
    .addCase(getBandProducts.rejected, (state, action) => {
      state.products.loading = false;
      state.products.error = action.payload;
    });
};

// Band Orders Builders
export const getBandOrdersBuilder = (builder) => {
  builder
    .addCase(getBandOrders.pending, (state) => {
      state.orders.loading = true;
      state.orders.error = null;
    })
    .addCase(getBandOrders.fulfilled, (state, { payload }) => {
      const { data, total, perPage, page } = payload;
      state.orders.loading = false;
      state.orders.data = data;
      state.orders.total = total;
      state.orders.page = page;
      state.orders.perPage = perPage;
      state.orders.error = null;
    })
    .addCase(getBandOrders.rejected, (state, action) => {
      state.orders.loading = false;
      state.orders.error = action.payload;
    });
};

// Band Monthly Revenues Builders
export const getBandMonthlyRevenuesBuilder = (builder) => {
  builder
    .addCase(getBandMonthlyRevenues.pending, (state) => {
      state.monthlyRevenues.loading = true;
      state.monthlyRevenues.error = null;
    })
    .addCase(getBandMonthlyRevenues.fulfilled, (state, action) => {
      state.monthlyRevenues.loading = false;
      state.monthlyRevenues.data = action.payload;
      state.monthlyRevenues.error = null;
    })
    .addCase(getBandMonthlyRevenues.rejected, (state, action) => {
      state.monthlyRevenues.loading = false;
      state.monthlyRevenues.error = action.payload;
    });
};

export const getMonthlyBandRevenuesByPeriodBuilder = (builder) => {
  builder.addCase(getMonthlyBandRevenuesByPeriod.pending, (state) => {
    state.monthlyBandRevenuesByPeriod.loading = true;
    state.monthlyBandRevenuesByPeriod.error = null;
  });
  builder.addCase(
    getMonthlyBandRevenuesByPeriod.fulfilled,
    (state, { payload }) => {
      const { data } = payload;
      state.monthlyBandRevenuesByPeriod.data = data;
      state.monthlyBandRevenuesByPeriod.loading = false;
    }
  );
  builder.addCase(getMonthlyBandRevenuesByPeriod.rejected, (state, action) => {
    state.monthlyBandRevenuesByPeriod.loading = false;
    state.monthlyBandRevenuesByPeriod.error = action.error.message;
  });
};
